import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(
    localStorage.getItem("AMNAUTH") || sessionStorage.getItem("AMNAUTH") || null
  );
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("AMNData")) || JSON.parse(sessionStorage.getItem("AMNData")) || null
  );
  const [themeMode, setThemeMode] = useState(
    localStorage.getItem("AMN_THEME") || "dark"
  );

  useEffect(() => {
    localStorage.setItem("AMN_THEME", themeMode);
    if (themeMode === 'dark') {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
    } else {
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
    }
  }, [themeMode]);

  const toggleTheme = () => {
    setThemeMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  const logout = () => {
    setAuthToken(null);
    setUserData(null);
    localStorage.removeItem("AMNAUTH");
    localStorage.removeItem("AMNData");
    sessionStorage.removeItem("AMNAUTH");
    sessionStorage.removeItem("AMNData");
  };

  const login = (token, user) => {
    setAuthToken(token);
    setUserData(user);
    sessionStorage.setItem("AMNAUTH", token);
    sessionStorage.setItem("AMNData", JSON.stringify(user));
  };

  const isLoggedIn = Boolean(authToken);

  return (
    <AuthContext.Provider value={{ authToken, userData, login, logout, isLoggedIn, themeMode, toggleTheme }}>
      {children}
    </AuthContext.Provider>
  );
};
